module.exports = __webpack_public_path__ + "static/img/division_7.2aedc1d.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/coaching/widget/icons/game-ranks/fortnite/division_7.svg
// module id = VCFc
// module chunks = 35